export const contactsData = {
    email: 'hello@raviteja.pro',
    phone: '+1 (214)-892-0260',
    address: 'Knoxville, Tennessee',
    sheetAPI: ''
}